<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>地图基础能力案例</h2>
      <p>用一个尽量直白的高德地图示例，把常用初始化、落点、事件和图层切换串起来。</p>
    </div>

    <el-row :gutter="20">
      <el-col :span="24">
        <CodeCard
          title="高德地图基础操作"
          description="包括中心点切换、级别切换、示例点位、Marker 点击事件、地图点击落点与逆地址解析，以及天地图图层接入。"
          :codeContent="basisCode"
        >
          <BasisMapDemo />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import BasisMapDemo from '@/components/map/BasisMapDemo.vue'

export default {
  name: 'PcMapBasis',
  components: {
    CodeCard,
    BasisMapDemo
  },
  data() {
    return {
      // CodeCard 中展开源码时展示的简化示例代码。
      basisCode: `<template>
  <BasisMapDemo />
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  async mounted() {
    const AMap = await AMapLoader.load({
      key: 'YOUR_AMAP_KEY',
      version: '2.0',
      plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.Geocoder']
    })

    this.map = new AMap.Map(this.$refs.mapContainer, {
      center: [116.397428, 39.90923],
      zoom: 11,
      resizeEnable: true
    })

    this.map.on('click', this.handleMapClick)
  }
}
<\/script>`
    }
  }
}
</script>

<style scoped>
.skill-page {
  /* 覆盖全局 .skill-page：撑满内容区，内边距由内容区统一提供 */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0;
  background-color: transparent;
}

.page-header {
  margin-bottom: 30px;
  text-align: center;
}

.page-header h2 {
  margin-bottom: 10px;
  color: #303133;
}

.page-header p {
  color: #606266;
  font-size: 14px;
}
</style>
